import ElementorForms from './elementor-forms';

new ElementorForms();
